import { withRouter } from 'react-router-dom';
import { ButtonLink } from '../../../components/Button';
import { SearchDetailNavigationContainer } from '../../../components/SearchDetail';
import { SvgIcon } from '../../../components/SvgIcon';
import {
  withBreakpoints,
  WithBreakpointsProps
} from '../../../provider/BreakpointProvider/withBreakpoints';
import {
  withSearch,
  WithSearchProps
} from '../../../provider/SearchProvider/withSearch';
import { selectSearchDetailVehicleId, selectSearchMenuEntry } from '../../../provider/Typo3Provider/selectors';
import Typo3Label from '../../../provider/Typo3Provider/Typo3Label';
import { getVehicleDetailPath } from '../../../provider/Typo3Provider/utils';
import {
  withTypo3,
  WithTypo3Props
} from '../../../provider/Typo3Provider/withTypo3';

interface SearchDetailNavigationProps {}

const SearchDetailNavigation = ({
  typo3,
  search,
  breakpoints
}: SearchDetailNavigationProps &
  WithTypo3Props &
  WithSearchProps &
  WithBreakpointsProps) => {
  const activeVehicleId = selectSearchDetailVehicleId(typo3);

  if (!activeVehicleId || search.detailNavigationOffers.length === 0) {
    return null;
  }

  const searchEntry = selectSearchMenuEntry(typo3);
  const activeIndex = search.detailNavigationOffers.findIndex(
    item => item.vehicleId === activeVehicleId
  );

  const prevEntry = search.detailNavigationOffers[activeIndex - 1];
  const nextEntry = search.detailNavigationOffers[activeIndex + 1];

  const prevDetailLink = prevEntry ? getVehicleDetailPath(typo3, prevEntry.vehicleId) : undefined;
  const nextDetailLink = nextEntry ? getVehicleDetailPath(typo3, nextEntry.vehicleId) : undefined;

  const { medium } = breakpoints;

  return (
    <SearchDetailNavigationContainer>
      {prevDetailLink && (
        <ButtonLink
          small
          inlined
          rotate={90}
          to={prevDetailLink}
        >
          <SvgIcon icon={'arrow'} />
          {medium && (
            <span>
              <Typo3Label label="searchDetail.navigation.prev" />
            </span>
          )}
        </ButtonLink>
      )}

      {searchEntry && (
        <ButtonLink small inlined to={searchEntry.link}>
          <Typo3Label label="searchDetail.navigation.overview" />
        </ButtonLink>
      )}

      {nextDetailLink && (
        <ButtonLink
          small
          inlined
          rotate={-90}
          to={nextDetailLink}
        >
          {medium && (
            <span>
              <Typo3Label label="searchDetail.navigation.next" />
            </span>
          )}
          <SvgIcon icon={'arrow'} />
        </ButtonLink>
      )}
    </SearchDetailNavigationContainer>
  );
};

export default withRouter(
  withBreakpoints(withSearch(withTypo3(SearchDetailNavigation)))
);
